module.exports = __webpack_public_path__ + "shopify.svg?8e4eeec3663c308b963859fad59f49e0";